<div class="master-modal reviepw_items_modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <div class="modal-header">
        <h4 class="modal-title"> Delete </h4>
        <div class="modal_close_btn">
          <span (click)="closeDialog('no')" class="modal-close"><i class="material-icons">close</i></span>
        </div>
      </div>
      <!-- Modal content-->
        <perfect-scrollbar class="modal-body-scrollbar">
          <div mat-dialog-content>
            <div class="modal-body">
               <p>
                 Are you really want to delete this account ?
               </p>
            </div>
          </div>
        </perfect-scrollbar>
        <!-- Modal-Footer -->
        <div class="modal-footer">
          <div mat-dialog-actions class="modal_footer">
            <button type="button" mat-button (click)="closeDialog('no')" class="modal-cancel-btn modal-footer-btn">
              <span> Cancel </span>
            </button>
            <button type="button" mat-button (click)="delete()" class="modal-save-btn global-btn">
              <span> Delete </span>
            </button>
          </div>
        </div>
    </div>
  </div>
</div>
